import { SEO_CONFIG } from '@/config/seoConfig'

const seo = {
  state: {
    currentPageType: null // null, 'home', 'event', 'vip'
  },
  getters: {
    seoH1Text: (state, getters, rootState) => {
      const isThemeGold = process.env.VUE_APP_THEME === 'theme_gold'

      // 如果不是 theme_gold 或沒有設定頁面類型，返回空
      if (!isThemeGold || !state.currentPageType) {
        return ''
      }

      const config = SEO_CONFIG[state.currentPageType]
      if (!config || !config.getH1) {
        return ''
      }

      return config.getH1(rootState)
    },
    seoH2Text: (state, getters, rootState) => {
      const isThemeGold = process.env.VUE_APP_THEME === 'theme_gold'

      // 如果不是 theme_gold 或沒有設定頁面類型，返回空陣列
      if (!isThemeGold || !state.currentPageType) {
        return []
      }

      const config = SEO_CONFIG[state.currentPageType]
      if (!config || !config.getH2) {
        return []
      }

      return config.getH2(rootState)
    }
  },
  mutations: {
    SET_PAGE_TYPE(state, pageType) {
      state.currentPageType = pageType
    }
  },
  actions: {}
}

export default seo
